import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import Spinner from 'components/ui/Spinner';
import Sidebar from 'components/modules/carrier/AdminSidebar';
import NotificationsManager from 'components/modules/notifications/manage-notifications';
import { useTranslation } from 'react-i18next';
const Loading = function () {
    return (React.createElement("div", { className: "justify-center lg:col-span-1", style: { top: '50%' } },
        React.createElement("div", { className: "align-middle" },
            React.createElement("span", { className: "text-5xl text-green" },
                React.createElement(Spinner, { showMessage: false })))));
};
const NotificationsSettings = () => {
    const { t } = useTranslation();
    const [carrier, setCarrier] = useState(null);
    const params = useParams();
    const carrierId = params.id;
    const renderSidebar = () => (React.createElement(Sidebar, { userId: carrierId, activePage: "notifications" }));
    const breadcrumbs = {
        pages: [
            {
                name: (carrier === null || carrier === void 0 ? void 0 : carrier.name) || t('CARRIER'),
                href: `/users/${carrierId}`,
                current: false,
            },
            {
                name: 'Notifications',
                href: `/users/${carrierId}/carrier-settings/notifications`,
                current: true,
            },
        ],
    };
    useEffect(() => {
        fetchUser();
    }, []);
    const fetchUser = async () => {
        const user = await getCustomerV2(carrierId);
        setCarrier(user);
    };
    return (React.createElement(LayoutWithSidebar, { sidebar: renderSidebar, breadcrumbs: breadcrumbs, className: "py-4" }, carrier ? (React.createElement(NotificationsManager, { userNotificationPreferences: carrier })) : (React.createElement(Loading, null))));
};
export default NotificationsSettings;
